var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { LitElement, html, css } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { localized, msg } from '@lit/localize';
import { CommonActions } from '../../../localization/helpers.js';
let ExportNetworkForm = class ExportNetworkForm extends LitElement {
    constructor() {
        super(...arguments);
        this.exportFormats = [
            { value: 'csv', label: 'CSV' },
            { value: 'geojson', label: 'GeoJSON' },
            { value: 'xlsx', label: 'Excel' },
        ];
        this.selectedFormat = this.exportFormats[0].value;
    }
    handleExport() {
        const event = new CustomEvent('submit-export-network', {
            detail: { format: this.selectedFormat },
            bubbles: true,
            composed: true,
        });
        this.dispatchEvent(event);
    }
    handleCancel() {
        const event = new CustomEvent('cancel-export-network', {
            bubbles: true,
            composed: true,
        });
        this.dispatchEvent(event);
    }
    handleFormatChange(event) {
        this.selectedFormat = event.detail.value; // Met à jour le format sélectionné
    }
    render() {
        return html `
      <div class="form-group">
        <label for="export-format">${msg('Export format:', { id: 'network.export.format', desc: 'Export format label' })}</label>
        <select-input
          id="export-format"
          .options="${this.exportFormats}"
          .value="${this.selectedFormat}"
          .variant="primary"
          size="medium"
          @select-change="${this.handleFormatChange}"
        ></select-input>
      </div>
      <div class="buttons">
        <simple-button
          variant="secondary"
          @button-click="${this.handleCancel}"
          label=${CommonActions.cancel()}
        ></simple-button>
        <simple-button
          variant="primary"
          special
          @button-click="${this.handleExport}"
          label=${CommonActions.export()}
        ></simple-button>
      </div>
    `;
    }
};
ExportNetworkForm.styles = css `
    :host {
      display: flex;
      flex-direction: column;
      gap: 10px;
      font-family: inherit;
      color: black;
    }

    .form-group {
      display: flex;
      flex-direction: column;
    }

    label {
      margin-top: 5px;
      font-size: 14px;
      margin-bottom: 5px;
      color: black;
    }

    .buttons {
      display: flex;
      justify-content: flex-end;
      gap: 10px;
    }
  `;
__decorate([
    property({ type: Array })
], ExportNetworkForm.prototype, "exportFormats", void 0);
__decorate([
    property({ type: String })
], ExportNetworkForm.prototype, "selectedFormat", void 0);
ExportNetworkForm = __decorate([
    localized(),
    customElement('export-network-form')
], ExportNetworkForm);
export { ExportNetworkForm };
//# sourceMappingURL=ExportNetworkForm.js.map